import { render, staticRenderFns } from "./JourneyBrickSquareEndpoints.vue?vue&type=template&id=ba0da6b6&"
import script from "./JourneyBrickSquareEndpoints.vue?vue&type=script&lang=js&"
export * from "./JourneyBrickSquareEndpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba0da6b6')) {
      api.createRecord('ba0da6b6', component.options)
    } else {
      api.reload('ba0da6b6', component.options)
    }
    module.hot.accept("./JourneyBrickSquareEndpoints.vue?vue&type=template&id=ba0da6b6&", function () {
      api.rerender('ba0da6b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBrickSquareEndpoints.vue"
export default component.exports